// extracted by mini-css-extract-plugin
module.exports = {"comment":"CommentComposeLayout__comment__JCPWj","avatar":"CommentComposeLayout__avatar__m8jI0","inputContainer":"CommentComposeLayout__inputContainer__Aw5Fh"};